import Axios from 'axios'
// import { DemoData } from '../../../data/demoData'
import notify from 'devextreme/ui/notify'
import store from '../../../store'
import router from '../../../../router/router'

const accountDetails = {
    namespaced: true,
    state: {
        profile: {},
        // location: [], //{ description: '', devices: [] },
        authenticated: false,
        type: ''
    },
    mutations: {
        setPf(state, pf) {
            //debugger;
            state.profile = pf.profile
                ? pf.profile : null
            state.authenticated = pf.authenticated
            state.type = pf.type
            ////debugger;
            // state.devices = pf.devices ? pf.devices : null
            // state.location = pf.profile.preferredLocation ? pf.profile.preferredLocation : { description: '--', locationNo: '--', devices: [] }
        },
        setType(state, t) {
            state.type = t ? t : ''
        },
        setDashboard(state, dashbrd) {
            state.dashboard = dashbrd
        },
        setDevices(state, dev) {
            state.devices = dev

        },
        setCurrentLocation(state, loc) {
            state.location = loc;
        },
        setAuthentication(state, status) {
            state.authenticated = status
        }
    },
    actions: {
        login({ commit }, creds) {

            creds.confirm = creds.password;

            this.dispatch('updateStat', true)

            return Axios.post('api/account/login', creds)
                .then(response => {
                    // debugger


                    // Set User Profile:
                    this.dispatch('updateStat', false)

                    var type = response.data.success ? 'success' : 'error'

                    if (response.data.success) {
                        var pf = {
                            profile: response.data.msg.profile,
                            type: response.data.msg.type,
                            authenticated: response.data.success,
                        }

                        commit('setPf', pf)

                        return response.data.success;
                    } else {

                        return notify(response.data.msg, type, 4000);
                    }


                    // Init call to get orders and cases:
                    return

                }).catch(reason => {
                    ////debugger;
                    this.commit('updateStat', false)
                    notify(reason.message, 'error', 4000)

                    return;
                })
            // }
        },
        async refresh({ commit }) {
            return Axios.get('api/account/authenticated')
                .then(response => {
                    // debugger
                    var profile = response.data.msg.profile;
                    var authType = response.data.msg.type;

                    var pf = {
                        authenticated: response.data.success,
                        profile: profile ? profile : {},
                        type: authType ? authType : ''
                    }


                    commit('setPf', pf)
                    // str.dispatch('Location/currentLocation', pf.profile.preferredLocation)
                    return
                })
                .catch(err => {
                    console.error(err.message)
                    var pf = {
                        authenticated: false,
                        profile: {},
                    }
                    notify(err.message, 'error', 4000);
                    commit('setPf', pf)
                    return
                })
        },
        logout({ commit }) {


            return Axios.get('api/account/logout')
                .then(() => {
                    commit('setPf', {
                        profile: null,
                        authenticated: false,
                        locations: null,
                    })
                })
                .catch(err => console.log(err.message))

        },
        proFile({ commit, state }, profile) {
            return Axios.put('api/account/profile', profile)
                .then(response => {
                    var type = response.data.success ? "success" : "error";

                    if (response.data.success) {
                        return this.dispatch("user/refresh")
                            .then(() => {
                                notify(response.data.msg, type, 4000)
                                return true;
                            })

                    } else {

                        notify(response.data.msg, type, 4000)

                        return false
                    }

                })
                .catch(err => {
                    console.error(err)
                    notify('Update failed!', 'error', 4000)
                    return false
                });
        },
        isAllowed({ commit, state }) {
            return Axios.get('api/account/allowed')// return Axios.get('api/account/allowed' + '?uid=' + state.profile.id)
                .then(response => {
                    commit('setType', response.data)
                    return response.data
                })
                .catch(err => notify(err, 'failed'))
        },
        forgotPass({ commit }, cred) {
            debugger;
            if (cred.email.indexOf('@') < 0 || cred.email.indexOf('.') < 0) {
                notify("Invalid email format, please try again.", 'error', 4000);
                return false;
            }

            return Axios.post('api/account/forgot', cred)
                .then(r => {
                    var type = r.data.success ? 'success' : 'error'
                    notify(r.data.msg, type, 4000);
                    return r.data.success;
                })
                .catch(err => {
                    notify(err.message, 'error', 4000);
                    return false;
                })
        },
        resetPass({ commit }, cred) {

            if (cred.password !== cred.confirm) {
                notify("Password and password confirmation do not match, please try again!", 'error', 4000);
                return false;
            }

            return Axios.post('api/account/reset', cred)
                .then(r => {
                    var type = r.data.success ? 'success' : 'error'

                    notify(r.data.msg, type, 4000)

                    return r.data.success;
                })
                .catch(err => {
                    notify(err.message, 'error', 4000);
                    return false;
                })

        }
    },
    getters: {
        isAuthenticated: state => state.authenticated,
        authType: state => state.type,
        isInternal: state => state.profile.is_internal,
        isAdmin: state => state.profile.is_admin,
        proFile: state => state.profile,
        location: state => state.location
    }
}

export default accountDetails;


// WEBPACK FOOTER //
// ./src/store/modules/common/LinkDsg/auth.js